module.exports = __webpack_public_path__ + "img/default-user.99a96c48.svg";